import DOMPurify from 'dompurify'

/**
 * Sanitiza HTML antes de usar com dangerouslySetInnerHTML. Sempre que o conteúdo vier de um
 * campo editável por usuário (descrição de projeto/marco/wiki, comentário, mensagem), nunca
 * confiar que o HTML salvo é seguro para renderizar de volta.
 *
 * Contrato: aceita qualquer valor (a tipagem da API nem sempre reflete o dado real vindo do
 * banco). Só chama o DOMPurify se for uma string não vazia; qualquer outro caso (null,
 * undefined, número, objeto, etc.) retorna string vazia em vez de lançar erro.
 */
export function sanitizeHtml(html: unknown): string {
  if (typeof html !== 'string' || html.length === 0) {
    return ''
  }

  return DOMPurify.sanitize(html)
}

/**
 * Escapa texto para entrar como texto literal dentro de uma string HTML (ex.: `html` do Swal, que
 * renderiza HTML de verdade). Usar em todo valor digitado por usuário (nome de tag, de token...)
 * interpolado num template HTML. Diferente do `sanitizeHtml`, que limpa HTML que deve continuar
 * sendo HTML, aqui nada vira tag: o nome aparece exatamente como foi digitado.
 */
export function escapeHtml(value: unknown): string {
  if (value === null || value === undefined) {
    return ''
  }

  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}
